<template>
  <div>
    <b-button size="sm" v-b-modal="modalId">
      {{ 'Send List to eTapestry' }}
    </b-button>
    <b-modal ref="journalModal"
      :id=modalId
      centered
      size="lg"
      title="Create Journal Entry for eTapestry"
      no-close-on-backdrop
    >
      <form @submit.prevent
        class="needs-validation"
        autocomplete="off"
        novalidate
      >
        <div v-if="serverError" class="alert alert-danger" role="alert">
          {{serverError}}
        </div>
        <div>
          <p>{{`This will create and send an eTapestry 'Journal Entry' with the
            ${getSelectedIdsCount()} contacts based on your search and selection.
            Please enter a unique name for this Journal Entry to send the list to eTapestry.`}}</p>
        </div>
        <div class="form-row form-group row">
          <label for="name" class="label-text col-lg-4">
            <span class="text-danger">*</span>Journal Entry Name
          </label>
          <div class="col-lg-8">
            <input
              v-validate="'required|min:5|max:25'"
              data-vv-as="Journal Entry Name"
              type="text"
              class="form-control"
              name="journalEntryName"
              v-model="journalEntryName"
              @input="removeServerErrors"
              placeholder="Enter Journal Entry Name"
            />
          <div class="invalid-feedback">{{ errors.first('journalEntryName') }}</div>
          </div>
        </div>
        <div>
          <p>When done, access the list of contacts in eTapestry by querying Accounts by
            Journal Entry Note using the name you enter here.</p>
        </div>
        <LoadingSpinner v-if="isLoading" message="Sending Journal Entries" size='0.5x'>
        </LoadingSpinner>
        <b-alert variant="success" :show="(successMessage !== '')">{{successMessage}}</b-alert>
      </form>
      <div slot="modal-footer" class="d-flex justify-content-center w-100">
        <b-button variant="danger" class="button-row-spacing" @click="hideModal">Cancel</b-button>
        <b-button class="button-row-spacing"
          :disabled="isSendButtonDisabled()"
          @click="sendListToEtapestry"
        >
          Send
        </b-button>
      </div>
    </b-modal>
  </div>
</template>

<script>
import api from '@/api';
import LoadingSpinner from '../LoadingSpinner.vue';


export default {
  name: 'JournalEntryModal',
  data() {
    return {
      journalEntryName: '',
      serverError: null,
      successMessage: '',
      isLoading: false,
    };
  },
  props: {
    modalId: {
      type: String,
    },
  },
  components: {
    LoadingSpinner,
  },
  methods: {
    isSendButtonDisabled() {
      return (this.serverError != null || (this.errors.first('journalEntryName') != null));
    },
    hideModal() {
      this.$refs.journalModal.hide();
      this.removeErrors();
    },
    getSelectedIdsCount() {
      return this.$store.state.Contact.selectedSearchContacts.length;
    },
    removeServerErrors() {
      this.serverError = null;
    },
    removeErrors() {
      this.serverError = null;
      this.journalEntryName = '';
    },
    sendListToEtapestry() {
      this.isLoading = true;
      const pageNumber = 0;
      const pageSize = 20;
      const crmIds = this.$store.state.Contact.selectedSearchContacts;
      const journalName = this.journalEntryName;
      this.sendContactPage(pageNumber, crmIds, pageSize, journalName);
    },
    sendContactPage(pageNumber, crmContactIds, pageSize, journalName) {
      const journalNameSeries = journalName;
      const remainingContact = crmContactIds.length - (pageNumber * pageSize);
      if (remainingContact >= pageSize) {
        const journalModel = {
          journalName: journalNameSeries,
          crmContactIds: crmContactIds.slice(pageSize * pageNumber, pageSize * (pageNumber + 1)),
        };
        this.contactPost(journalModel).then(() => this.sendContactPage(
          pageNumber + 1, crmContactIds, pageSize, journalName,
        ));
      } else {
        const journalModel = {
          journalName: journalNameSeries,
          crmContactIds: crmContactIds.slice(
            pageSize * pageNumber,
            crmContactIds.length,
          ),
        };
        this.contactPost(journalModel).then(() => {
          this.isLoading = false;
          this.successMessage = 'The Journal Entry has been successfully added.';
          setTimeout(() => {
            this.onSuccess();
          }, 3000);
        });
      }
    },
    contactPost(journalModel) {
      return api.post('/contact/pushjournalentry', journalModel)
        .catch((error) => {
          this.serverError = error.response.data;
        });
    },
    onSuccess() {
      this.successMessage = '';
      this.hideModal();
    },
  },
};
</script>
